import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import * as fromSettings from 'src/app/shared/state/setting.reducer';

interface Setting {
  id: string;
  title: string;
}

export const SETTING_DROPDOWN_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SettingDropdownComponent),
  multi: true
};

export const SETTING_DROPDOWN_INPUT_CONTROL_VALIDATOR: any = { provide: NG_VALIDATORS, useExisting: forwardRef(() => SettingDropdownComponent), multi: true };

@Component({
  selector: 'app-setting-dropdown',
  templateUrl: './setting-dropdown.component.html',
  styleUrls: ['./setting-dropdown.component.scss'],
  providers: [SETTING_DROPDOWN_INPUT_CONTROL_VALUE_ACCESSOR, SETTING_DROPDOWN_INPUT_CONTROL_VALIDATOR]
})
export class SettingDropdownComponent implements OnInit, OnDestroy, ControlValueAccessor, Validator {
  @Input() label = 'settingDropdown';
  @Input() name = 'settingDropdown';
  @Input() setting = 'settingDropdown';
  @Input() unset = '-- bitte auswählen --';
  @Input() inline = false;
  @Input() required = false;
  @Input() showID = false;

  value: Setting;
  settings: Setting[] = [];
  filteredSettings: Setting[] = [];

  private destroy$ = new Subject<void>();

  constructor(private store: Store<fromSettings.SettingsState>) { }

  ngOnInit(): void {
    this.store.select(fromSettings.getSettings).pipe(
      filter(settings => settings.length > 0),
      takeUntil(this.destroy$)
    ).subscribe(settings => {
      const rawSettings = settings.filter(item => item.name === this.setting)?.[0]?.data;
      if (this.showID) {
        this.settings = [];
        rawSettings.forEach((setting) => {
          const id = setting?.id ?? setting;
          const title = setting?.id ? `${id} - ${setting.title}` : setting;
          this.settings.push({ id, title });
        });
      } else {
        this.settings = rawSettings;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changes() {
    this.propagateChange(this.value?.id);
  }

  clear() {
    this.value = null;
    this.changes();
  }

  // From ControlValueAccessor interface
  writeValue(value: string) {
    const setting = this.settings.find((setting) => setting.id == value);

    if (setting) {
      this.value = setting;
    }
  }

  propagateChange = (_: any) => { };

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

  validate(ctrl: AbstractControl) {
    return null;
  }

  filter(event) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.settings.length; i++) {
      const setting = this.settings[i];
      const title = typeof setting === 'string' ? setting : setting.title;
      if (title.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        filtered.push(setting);
      }
    }

    this.filteredSettings = filtered;
  }
}
